import React, { useState, useEffect, useCallback,useRef } from "react";
import data from "../../assets/apiRoutes.json";
import DropDownButton from "devextreme-react/drop-down-button";
import { connect } from "react-redux";
import "devextreme/data/odata/store";
import { GridLayout } from "../../common/GridLayout";
import {
  Column,
  DataGrid,
  GroupPanel,
  Grouping,
  FilterRow,
  FilterPanel,
  Sorting,
  Paging,
  Pager,
  LoadPanel,
  Export,
  ColumnHeaderFilter,
  ColumnChooser,
  ColumnChooserSearch,
  StateStoring,
  Toolbar,
  Item
} from "devextreme-react/data-grid";
import _ from "lodash";
import axios from "axios";
import GridLayoutManager from "../../gridLayoutCustomization/GridLayoutManager";

const buttonDropDownOptions = { width: 140 };
const TransactionItemsDetail = (props) => {
  const dataGrid = useRef(null);
  const [loading, setLoading] = useState("Data Loading");
  const [currentLayout, setCurrentLayout] = useState("Default");
  const SearchPanelAccordionStatus = props.SearchPanelAccordionStatus;
  var accessToken = props.oidc.user.access_token;
  const [changeReceiptItems, setChangeReceiptItems] = useState({
    itemStatus: "A",
    companyId: "SB",
    module: "WM",
    recordType: "R",
    transactionHeaderId: props.id,
    isTransItmsOnly: props?.isTransItmsOnly ? props.isTransItmsOnly : false,
    dbName:
      props.ReceiptReducer.wmTransactionDatabase !== ""
        ? props.ReceiptReducer.wmTransactionDatabase
        : "",
  });

  //const dataSource = createStore({
  //  key: 'rowid',
  //  loadUrl: `${window._env_.REACT_APP_APIS}/${data.Receipt.changeReceiptItems2}`,
  //  onBeforeSend: function (method, ajaxOptions) {
  //    ajaxOptions.headers = {
  //      access_token: accessToken,
  //      Authorization: `Bearer ${accessToken}`,
  //    };
  //  }
  //});

  // tabs handling
  const [currentTab, setCurrentTab] = useState(0);
  const changeCurrentTab = (e) => {
    setCurrentTab(e.itemData.tab);
    var request = {
      value: e.itemData.tab,
      id: e.itemData.rowId,
      lotId: e.itemData.lotId,
      serialNumbRowid: e.itemData.serialNumbRowid,
      lotcode: e.itemData.lotcode,
      itemcode: e.itemData.itemcode,
      detailrowid: e.itemData.detailrowid
    };
    props.changeTab(request);
  };
  const loadChangeReceiptItems = () => {
    axios
      .post(
        `${window._env_.REACT_APP_APIS}/${data.Receipt.changeReceiptItems}`,
        changeReceiptItems,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then((result) => {
        let itemsArray = [];
        itemsArray = result.data.items;
        var detailItems = result.data.selectedDetailItems.filter(
          (items) => items.quantityorder > 0
        );
        var sortedItems = _.orderBy(detailItems, ["quantityorder"], ["desc"]);

        if (itemsArray != null && itemsArray.length > 0) {
          var pulledItems = _.pullAllBy(itemsArray, sortedItems, "rowid");
          var combinedItems = _.unionBy(sortedItems, pulledItems, "rowid");
          setChangeReceiptItems(combinedItems);
          if (combinedItems.length > 0)
            setLoading("Data loading");
          else
            setLoading("No Data found");
        } else {
          setChangeReceiptItems(sortedItems);
          if (sortedItems.length > 0)
            setLoading("Data loading");
          else
            setLoading("No Data found");
        }
      })
      .catch((err) => {
        console.log(err, "error in data loading");
      });
  };

  useEffect(() => {
    loadChangeReceiptItems();
  }, []);
  const allowedPageSizes = [5, 10, 20, "all"];

  const gridKey = "0ac27926-7017-4e49-b5f7-e1649adc9c39";
  const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
  const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);

  return (
    <div>
      <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
        ref={dataGrid}
        noDataText={loading}
        dataSource={changeReceiptItems}
        showBorders={true}
        className={SearchPanelAccordionStatus ? "GridHeightAccordianOpen-tabs" : "GridHeightAccordianClose-tabs"}
        hoverStateEnabled={true}
        allowColumnResizing={true}
        allowColumnReordering={true}
        columnAutoWidth={true}
      >
        <ColumnChooser
          enabled={true}
          title="Choose Column"
          width={290}
          height={290}
          sortOrder="asc"
        >
          <ColumnChooserSearch
            enabled={true}
            editorOptions={{ placeholder: 'Search column' }} />
        </ColumnChooser>
        <ColumnHeaderFilter />
        <Export enabled={true} allowExportSelectedData={true} text="Export" />
        <Sorting visible={true} mode="multiple" />
        <LoadPanel enabled={true} />
        <Paging defaultPageSize={10} />
        <Pager
          visible={true}
          showPageSizeSelector={true}
          allowedPageSizes={allowedPageSizes}
          showNavigationButtons={true}
        />
        <FilterRow visible={true} />
        <FilterPanel visible={true} />
        <GroupPanel visible={true} />
        <Grouping autoExpandAll={false} />
        <StateStoring
          enabled={true}
          type="custom"
          customLoad={loadState}
          storageKey={gridKey}
          customSave={saveState}
        />
        <Column
          dataField="rowid"
          caption=""
          cellRender={(rowid) => cellRender(rowid)}
        />
        <Column
          dataField="quantityorder"
          dataType="number"
          caption="Ordered"
        ></Column>
        <Column dataField="itemcode" caption="Item"></Column>
        <Column dataField="description1" caption="Item Description - 1"></Column>
        <Column
          dataField="description2"
          caption="Item Description 2"
          visible={false}
        ></Column>

        <Column dataField="classcode" caption="Class" visible={false}></Column>
        <Column
          dataField="subclasscode"
          caption="SubClass"
          visible={false}
        ></Column>
        <Column dataField="status" caption="Status"></Column>
        <Column
          dataField="dateavailable"
          dataType="date"
          caption="Item Date Available"
          visible={false}
        ></Column>
        <Column
          dataField="dateexpiration"
          dataType="date"
          caption="Item Date Expiration"
          visible={false}
        ></Column>
        <Column dataField="netavailable" caption="Item Net Avl"></Column>
        <Column dataField="receiptuomdefault" caption="UOM Default"></Column>
        <Column
          dataField="receiptpacksize"
          caption="Pack Size"
          visible={false}
        ></Column>
        <Column dataField="lotid" caption="Lot Id" visible={false}></Column>
        <Column
          dataField="palletsizecode"
          caption="Pallets"
          visible={false}
        ></Column>
        <Column dataField="lotcode" caption="Lot"></Column>
        <Column dataField="lotDescription1" caption="Lot Description - 1"></Column>
        <Column
          dataField="lotDescription2"
          caption="Lot Description - 2"
          visible={false}
        ></Column>
        <Column
          dataField="lotUserdefinedreference8"
          caption="Lot Reference 8"
          visible={false}
        ></Column>
        <Column dataField="lotNetavailable" caption="Lot Net Avl"></Column>
        <Column
          dataField="lotDateExpiration"
          dataType="date"
          caption="Lot Date Expiration"
          visible={false}
        ></Column>
        <Column
          dataType="date"
          dataField="lotDateAvailable"
          caption="Lot Date Available"
          allowEditing={false}
          visible={false}
        ></Column>
        <Column
          dataType="date"
          dataField="lotDateIntroduced"
          caption="Lot Date Introduced"
          allowEditing={false}
          visible={false}
        ></Column>
        <Column
          dataField="lotUnitPerPackage"
          caption="Lot Units / Package"
          allowEditing={false}
          visible={false}>
        </Column>
        <Column
          dataField="lotFirstReceipt"
          caption="Lot First Receipt"
          allowEditing={false}
          visible={false}>
        </Column>
        <Column dataField="transunits" caption="Trans Units"></Column>
        <Column dataField="actual" caption="Actual"></Column>
        <Toolbar>
          <Item location="after">
            <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
          </Item>
          <Item name="exportButton" />
          <Item name="columnChooserButton" />
        </Toolbar>
      </DataGrid>
    </div>
  );
  function cellRender(rowid) {
    return (
      <DropDownButton
        className="dropdownWithoutText"
        dropDownOptions={buttonDropDownOptions}
        items={[
          {
            name: "Sub Lots",
            tab: 1,
            rowId: rowid.data.rowid,
            lotId: rowid.data.lotid,
            lotcode: rowid.data.lotcode,
            itemcode: rowid.data.itemcode,
          },
          {
            name: "Serial Number",
            tab: 2,
            rowId: rowid.data.rowid,
            serialNumbRowid: rowid.data.lotid,
            lotcode: rowid.data.lotcode,
            itemcode: rowid.data.itemcode,
            detailrowid: rowid.data.detailrowid
          },
          {
            name: "Location",
            tab: 3,
            rowId: rowid.data.rowid,
            lotId: rowid.data.lotid,
            lotcode: rowid.data.lotcode,
            itemcode: rowid.data.itemcode,
          },
        ]}
        displayExpr="name"
        onItemClick={(e) => changeCurrentTab(e)}
        // onSelectionChanged={(e) => changeCurrentTab(e)}
        keyExpr="rowId"
      />
    );
  }
};
const mapStateToProps = (state) => {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
};
export default connect(mapStateToProps)(TransactionItemsDetail);
